import { formatManagerName } from '../../../pages/price-surveys/helpers';
import { ProductListOption, SelectOption, SurveyScopeKind } from './types';

export function getSurveyScopeQueryInput(
    scopeKind: SurveyScopeKind,
    scopeId: string,
): { advertisingZoneId: string } | { storeId: string } {
    if (scopeKind === 'ZONE') {
        return { advertisingZoneId: scopeId };
    }

    return { storeId: scopeId };
}

export function getActiveScopeId(
    scopeKind: SurveyScopeKind,
    advertisingZoneId: string,
    storeId: string,
): string {
    if (scopeKind === 'ZONE') {
        return advertisingZoneId;
    }

    return storeId;
}

export function getProductListPlaceholder({
    listsLoading,
    activeScopeId,
    hasLists,
    isZoneScope,
}: {
    listsLoading: boolean;
    activeScopeId: string;
    hasLists: boolean;
    isZoneScope: boolean;
}): string {
    if (listsLoading) {
        return 'Loading lists...';
    }

    if (!activeScopeId) {
        return 'Select a zone or store first';
    }

    if (!hasLists) {
        if (isZoneScope) {
            return 'No product list found for this advertising zone';
        }

        return 'No product list found for this store';
    }

    return 'Select labelled upload';
}

export function getProductListNothingFoundMessage(
    isZoneScope: boolean,
): string {
    if (isZoneScope) {
        return 'No product list found for this advertising zone';
    }

    return 'No product list found for this store';
}

export function mapZonesToOptions(
    zones: Array<{ id: string; name: string }>,
): SelectOption[] {
    return zones.map(zone => ({
        value: zone.id,
        label: zone.name,
    }));
}

export function mapStoresToOptions(
    stores: Array<{ id: string; name: string; storeNo: string }>,
): SelectOption[] {
    return stores.map(store => ({
        value: store.id,
        label: `${store.storeNo} - ${store.name}`,
    }));
}

export function mapManagersToOptions(
    managers: Array<{ id: string; firstName: string; lastName: string }>,
): SelectOption[] {
    return managers.map(manager => ({
        value: manager.id,
        label: formatManagerName(manager) || 'Unknown Manager',
    }));
}

export function mapProductListsToOptions(
    productLists: ProductListOption[],
): SelectOption[] {
    return productLists.map(list => ({
        value: list.manualDataImportLogId,
        label: `${list.label} (${list.productCount} products)`,
    }));
}
